module.exports = __webpack_public_path__ + "img/empty-page.c2095fe3.svg";